import { Link } from '@remix-run/react'

const Footer = () => {
	return (
		<footer className="bg-[url('/img/footer-background-mobile.svg')] bg-cover bg-no-repeat md:bg-[url('/img/footer-backround.svg')]">
			{/* desktop */}
			<div className="hidden md:block">
				<div className="flex flex-row justify-between px-14 pt-20 lg:px-40 lg:pt-32 2xl:pt-60">
					<div>
						<img src="img/notify-logo-black.svg" alt="notify-logo" />
					</div>
					<div className="space-y-8">
						<p className="font-bold">Menu</p>
						<div className="flex  gap-16 ">
							<div className="flex flex-col gap-2">
								<Link to="/">Domů</Link>
								<Link to="#benefits">Proč aplikaci?</Link>
								{/* <Link to="/marketing">Případové studie</Link>
								<Link to="/marketing">Recenze</Link> */}
							</div>
							<div className="flex flex-col gap-2">
								<Link to="#pricing">Ceník</Link>
								<Link to="#founders">O nás</Link>
								<Link to="#contact">Kontakt</Link>
							</div>
						</div>
					</div>
					<div className="space-y-8">
						<p className="font-bold">Kontakty</p>
						<div className="space-y-2">
							<Link to="mailto:aplikace@notify-shop.cz">
								aplikace@notify-shop.cz
							</Link>
							<p>+420 734 766 113</p>
						</div>
					</div>
				</div>
				<p className=" mb-6 mt-16 text-center lg:mt-10">
					Powered by{' '}
					<a
						href="https://blaze.codes"
						target="_blank"
						rel="noopener noreferrer"
						className=" font-bold text-primary"
					>
						blaze.codes
					</a>
				</p>
			</div>
			{/* mobile */}
			<div className="flex flex-col items-center gap-8 text-center md:hidden">
				<img
					src="img/notify-logo-black.svg"
					alt="notify-logo"
					className="pt-8"
				/>
				<div className="flex flex-col gap-2">
					<p className="font-bold">Menu</p>

					<div className="flex flex-col gap-2">
						<Link to="/">Domů</Link>
						<Link to="#benefits">Proč aplikaci?</Link>
						{/* <Link to="/">Případové studie</Link>
						<Link to="/">Recenze</Link> */}
						<Link to="#pricing">Ceník</Link>
						<Link to="#founders">O nás</Link>
						<Link to="#contact">Kontakt</Link>
					</div>
				</div>
				<div>
					<p className="mb-2 font-bold">Kontakty</p>
					<div>
						<p className="mb-2">aplikace@notify-shop.cz</p>
						<p>+420 734 766 113</p>
					</div>
				</div>
				<p className="mb-20 text-center">
					Powered by{' '}
					<a
						href="https://blaze.codes"
						target="_blank"
						rel="noopener noreferrer"
						className=" font-bold text-primary"
					>
						blaze.codes
					</a>
				</p>
			</div>
		</footer>
	)
}

export default Footer
